import React from "react";
import { Card, Text } from "react-native-paper";

import { THIRD_PARTY_CREDITS } from "../config/thirdPartyCredits";
import { useTheme } from "../context/ThemeContext";

/** "Data Credits" card for the About page (vocab-v2 §2 NOTICE). */
export const ThirdPartyCredits: React.FC = () => {
  const { theme } = useTheme();
  return (
    <Card style={{ marginBottom: 20, backgroundColor: theme.colors.surface }}>
      <Card.Content>
        <Text
          variant="headlineSmall"
          style={{ color: theme.colors.onSurface, marginBottom: 10 }}
        >
          Data Credits
        </Text>
        {THIRD_PARTY_CREDITS.map((c) => (
          <Text
            key={c.name}
            style={{ color: theme.colors.onSurface, lineHeight: 24 }}
          >
            {c.name} ({c.licence}): {c.use}
          </Text>
        ))}
        <Text
          style={{
            color: theme.colors.onSurface,
            lineHeight: 24,
            marginTop: 8,
          }}
        >
          The word graph and embedding are shared under CC BY-SA. Full notices:
          THIRD_PARTY_NOTICES.md in the Synapse repository.
        </Text>
      </Card.Content>
    </Card>
  );
};
